import React, { Component } from 'react';

import moment, { now } from 'moment';

import { Button, Icon, message, notification } from 'antd';
import CommonForm from '@common/components/form';
import ComuniService from '@common/services/locations/Comuni';

import formatter from '@common/utils/formatters/_';

import GestioneLR from '../../gestioneLR/services/GestioneLR'

const formLayout = (component) => {

    return {
      layout: 'vertical',
      multistep: false,
      rows: [
        {
          cols: [
            {
              items: [
                {
                  name: 'titolo_profilo',
                  type: 'title',
                  element: 'h4',
                  text: 'Nuovo Rappresentante legale',
                  props: {
                    style: { textAlign: 'left' },
                    className: 'm10h'
                  },
                },
              ],
            },
          ],
        },
        {
          cols: [
            {
              items: [
                {
                  type: 'input',
                  label: 'Nome',
                  type_string: 'text', // field type
                  name: 'nome',
                  props: {
                    //size: 'large',
                    disabled: component.state.readOnly,
                    prefix: <Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />,
                  },
                  validations: [
                    {
                      type: 'required',
                      error_message: 'Campo obbligatorio',
                    },
                  ],
                },
              ],
            },
            {
              items: [
                {
                  type: 'input',
                  label: 'Cognome',
                  type_string: 'text', // field type
                  name: 'cognome',
                  props: {
                    // size: 'large',
                    disabled: component.state.readOnly,
                    prefix: (
                      <Icon type="solution" style={{ color: 'rgba(0,0,0,.25)' }} />
                    ),
                  },
                  validations: [
                    {
                      type: 'required',
                      error_message: 'Campo obbligatorio',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          cols: [
            {
              span: 6,
              items: [
                {
                  type: 'datepicker',
                  label: 'Data di nascita',
                  name: 'nato_il',
                  format: 'DD/MM/YYYY',
                  props: {
                    // size: 'large',
                    style: { width: '100%' },
                    disabled: component.state.readOnly,
                  },
                  validations: [
                    {
                      type: 'required',
                      error_message: 'Campo obbligatorio',
                    },
                    {
                      validator: 'age18Validator'
                    }
                  ]
                },
              ],
            },
            {
              span: 6,
              items: [
                {
                  type: 'select',
                  label: 'Stato di nascita',
                  name: 'stato_nascita',
                  props: {
                    //size: 'large',
                    showSearch: true,
                    disabled: component.state.readOnly,
                    filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  },
                  validations: [
                    {
                      type: 'required',
                      error_message: 'Campo obbligatorio',
                    },
                  ],
                  options_props: 'nazioni',
                  onChange: 'selectedStatoNascita',
                },
              ],
            },
            {
              span: 6,
              items: [
                {
                  type: 'select',
                  label: 'Provincia di nascita',
                  name: 'provincia_nascita',
                  props: {
                    showSearch: true,
                    disabled: component.state.readOnly,
                    filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  },
                  showIf: [
                    {
                      type: 'field_validation',
                      field: 'stato_nascita',
                      operator: '==',
                      value: 1,
                    },
                  ],
                  validations: [
                    {
                      type: 'required',
                      error_message: 'Campo obbligatorio',
                    },
                  ],
                  options_props: 'province',
                  onChange: 'selectedProvinciaNascita',
                },
              ],
            },
            {
              span: 6,
              items: [
                {
                  type: 'select',
                  label: 'Comune di nascita',
                  name: 'comune_nascita',
                  props: {
                    showSearch: true,
                    disabled: component.state.readOnly,
                    filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  },
                  showIf: [
                    {
                      type: 'field_validation',
                      field: 'provincia_nascita',
                      operator: '!=',
                      value: null,
                    },
                    {
                      type: 'field_validation',
                      field: 'stato_nascita',
                      operator: '==',
                      value: 1,
                    },
                  ],
                  validations: [
                    {
                      type: 'required',
                      error_message: 'Campo obbligatorio',
                    }
                  ],
                  options_props: 'comuniNascita'
                },
              ],
            }
          ],
        },
        {
          cols: [
            {
              span: 12,
              items: [
                {
                  type: 'input',
                  label: 'Codice fiscale',
                  type_string: 'text', // field type
                  name: 'cf',
                  props: {
                    // size: 'large',
                    prefix: <Icon type="copy" style={{ color: 'rgba(0,0,0,.25)' }} />,
                    disabled: component.state.readOnly,
                  },
                  validations: [
                    {
                      type: 'required',
                      error_message: 'Campo obbligatorio',
                    },
                    {
                      pattern: '^[A-z0-9]{16}$',
                      message: 'Codice fiscale non valido'
                    },
                  ],
                },
              ],
            },
            {
              span: 12,
              items: [
                {
                  type: 'input',
                  label: 'Telefono',
                  type_string: 'text', // field type
                  name: 'telefono',
                  props: {
                    // size: 'large',
                    prefix: <Icon type="copy" style={{ color: 'rgba(0,0,0,.25)' }} />,
                    disabled: component.state.readOnly,
                  },
                  validations: [
                    {
                      type: 'required',
                      error_message: 'Campo obbligatorio',
                    },
                    {
                      pattern: '^([+]{0,1})([0-9 ]{6,50})$',
                      message: 'Telefono non valido'
                    },
                  ],
                },
              ],
            }
          ],
        },
        {
            cols: [
                {
                    span: 24,
                    items: [
                      {
                        type: 'input',
                        label: 'Email',
                        type_string: 'email', // field type
                        name: 'email',
                        props: {
                          size: 'large',
                          prefix: <Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />
                        },
                        validations: [
                          {
                            type: 'required',
                            error_message: 'Campo obbligatorio'
                          },
                          {
                            type: 'email',
                            error_message: 'Email non valida'
                          }
                        ],
                      },
                    ]  
                },
            ],
        },
        {
          cols: [
            {
              items: [
                {
                  name: 'titolo_residenze',
                  type: 'title',
                  element: 'h4',
                  text: 'Indirizzo di residenza nuovo rappresentante legale',
                  props: {
                    style: { textAlign: 'left' },
                    className: 'm10h'
                  },
                },
              ],
            },
          ],
        },
        {
          cols: [
            {
              span: 14,
              items: [
                {
                  type: 'input',
                  label: 'Via',
                  type_string: 'text', // field type
                  name: 'via',
                  props: {
                    // size: 'large'
                    disabled: component.state.readOnly,
                    prefix: (
                      <Icon type="pushpin" style={{ color: 'rgba(0,0,0,.25)' }} />
                    ),
                  },
                  validations: [
                    {
                      type: 'required',
                      error_message: 'Campo obbligatorio',
                    },
                  ],
                },
              ],
            },
            {
              span: 4,
              items: [
                {
                  type: 'input',
                  label: 'N',
                  type_string: 'text', // field type
                  name: 'ncivico',
                  props: {
                    // size: 'large',
                    placeholder: 'N.',
                    disabled: component.state.readOnly,
                  },
                  validations: [
                    {
                      type: 'required',
                      error_message: 'Campo obbligatorio',
                    },
                  ],
                },
              ],
            },
            {
              span: 6,
              items: [
                {
                  type: 'input',
                  label: 'Cap',
                  type_string: 'text', // field type
                  name: 'cap',
                  props: {
                    //size: 'large',
                    placeholder: 'Cap',
                    maxLength: 5,
                    disabled: component.state.readOnly,
                  },
                  validations: [
                    {
                      type: 'required',
                      error_message: 'Campo obbligatorio',
                    },
                    {
                      pattern: '[0-9a-zA-Z]{4,10}',
                      message: 'Cap non valido',
                    },
                  ],
                  showIf: [
                    {
                      type: 'field_validation',
                      field: 'stato_residenza',
                      operator: '==',
                      value: 1,
                    },
                  ],
                },
              ],
            }
          ],
        },
        {
          cols: [
            {
              span: 6,
              items: [
                {
                  type: 'select',
                  label: 'Nazione',
                  name: 'stato_residenza',
                  props: {
                    //size: 'large',
                    disabled: component.state.readOnly,
                    showSearch: true,
                    filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  },
                  validations: [
                    {
                      type: 'required',
                      error_message: 'Campo obbligatorio',
                    },
                  ],
                  options_props: 'nazioni',
                  onChange: 'selectedStatoResidenza',
                },
              ],
            },
            {
              span: 4,
              items: [
                {
                  type: 'select',
                  label: 'Provincia',
                  name: 'provincia_residenza',
                  props: {
                    // size: 'large',
                    allowClear: true,
                    showSearch: true,
                    disabled: component.state.readOnly,
                    filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  },
                  validations: [
                    {
                      type: 'required',
                      error_message: 'Campo obbligatorio',
                    },
                  ],
                  showIf: [
                    {
                      type: 'field_validation',
                      field: 'stato_residenza',
                      operator: '==',
                      value: 1,
                    }
                  ],
                  options_props: 'province',
                  onChange: 'selectedProvinciaResidenza',
                },
              ],
            },
            {
              span: 14,
              items: [
                {
                  type: 'select',
                  label: 'Comune',
                  name: 'comune_residenza',
                  props: {
                    disabled: component.state.readOnly,
                    showSearch: true,
                    filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  },
                  showIf: [
                    {
                      type: 'field_validation',
                      field: 'provincia_residenza',
                      operator: '!=',
                      value: null,
                    },
                    {
                      type: 'requiredIf',
                      error_message: 'Campo obbligatorio',
                      field: 'stato_residenza',
                      operator: '==',
                      value: 1,
                    }
                  ],
                  validations: [
                    {
                      type: 'required',
                      error_message: 'Campo obbligatorio',
                    }
                  ],
                  options_props: 'comuniResidenza'
                },
              ],
            }
          ],
        },
        {
            cols: [
              {
                items: [
                  {
                    name: 'data_inizio_validita_label',
                    type: 'title',
                    element: 'h4',
                    text: 'Data inizio validità',
                    props: {
                      style: { textAlign: 'left' },
                      className: 'm10h'
                    },
                  },
                ],
              },
            ],
          },
          {
            cols: [
              {
                span: 6,
                items: [
                  {
                    type: 'datepicker',
                    name: 'data_inizio_validita',
                    format: 'DD/MM/YYYY',
                    props: {
                      // size: 'large',
                      style: { width: '100%' },
                      disabled: true,
                    },
                  },
                ],
              },
            ],
        },
      ],
      onSubmit: 'submitted',
    }
  }

class DatiNuovoLR extends Component {

    state = {
        loading: false,
        readOnly: false,
        comuni_nascita: [],
        comuni_residenza: [],
    };

    async componentDidMount() {

        //if (this.props.values) this.setFileInState(this.props);
        this.loadComuniNascita(this.props)
        this.loadComuniResidenza(this.props)
      }
    
      loadComuniNascita(props) {
        if (props.ente.rappresentanteLegale.provincia_nascita) {
          this.selectedProvinciaNascita(props.ente.rappresentanteLegale.provincia_nascita)
        } else {
          this.setState({ loading: false });
    
          if (this.props.loadingComuni) {
            this.props.loadingComuni(false);
          }
        }
      }
    
      selectedProvinciaNascita(provincia) {
    
        this.setState({ loading: true });
    
    
        ComuniService.all(
          {
            id_provincia: provincia
          },
          res => {
    
            this.setState({
              loading: false,
              comuni_nascita: res.data.data || [],
              selected_nascita_provincia: provincia
            });
          },
          () => {
            this.setState({ loading: false });
          }
        );
      }

      loadComuniResidenza(props) {
        if (props.ente.rappresentanteLegale.provincia_residenza) {
          this.selectedProvinciaResidenza(props.ente.rappresentanteLegale.provincia_residenza)
        } else {
          this.setState({ loading: false });
    
          if (this.props.loadingComuni) {
            this.props.loadingComuni(false);
          }
        }
      }
    
      selectedProvinciaResidenza(provincia) {
    
        this.setState({ loading: true });
    
    
        ComuniService.all(
          {
            id_provincia: provincia
          },
          res => {
    
            this.setState({
              loading: false,
              comuni_residenza: res.data.data || [],
              selected_residenza_provincia: provincia
            });
          },
          () => {
            this.setState({ loading: false });
          }
        );
      }

      async validate() {
        return new Promise((resolve) => {
          this.formRefDatiRappr.props.form.validateFields((errors) => {
            if (!errors || errors.length === 0) {
              resolve(true);
            } else {
              message.error('Ricontrolla i campi');
              resolve(false);
            }
          });
        });
      }
    
      getFormData() {
        return formatter.replaceFormDatesOut(['nato_il', 'data_inizio_validita'], this.formRefDatiRappr.props.form.getFieldsValue());
      }
    
      /*
      getValues() {
        try {
          return formatter.replaceFormDatesIn(['nato_il'], {
            ...this.props.ente.rappresentanteLegale,
            telefono: this.props.ente.rappresentanteLegale.contatti && this.props.ente.rappresentanteLegale.contatti.length > 0 ? this.props.ente.rappresentanteLegale.contatti[0]['telefono'] : '',
          })
        } catch (e) {
          console.warn('TEST POINT 3: OK', e);
          return formatter.replaceIntegeresWithString(['comune_nascita'], this.props.ente.rappresentanteLegale);
        }
      }
      */

      async submitDatiRequest(){
        if (!this.state.loading) {
            if(await this.validate()) {
                this.setState({ loading: true, readOnly: true });
                GestioneLR.save(
                    {ente_id: this.props.ente.id, ...this.getFormData()},
                    (res) => {              
                        notification.success({ message: "Rappresentante Legale aggiornato con successo" });
                        window.scrollTo({ top: 0, behavior: "smooth" });            
                        this.setState({ loading: false });
                      },
                    (err) => {
                        notification.error({ message: err.message });
                        window.scrollTo({ top: 0, behavior: "smooth" }); 
                        this.setState({ loading: false, readOnly: false })
                    }
                );
            }
        }
      }

    render() {

    return (
      <div>
        <CommonForm
          wrappedComponentRef={inst => (this.formRefDatiRappr = inst)}
          loading={this.props.loading || false}
          form_model={formLayout(this)}
          values={
            {data_inizio_validita: moment().format('DD/MM/YYYY')}
            // this.getValues()
          }

          age18Validator={(rule, value, cb) => {
            var today = moment();
            if (today.diff(value, 'years') < 18) cb("Il rappresentante legale deve essere maggiorenne");
            else cb()
          }}

          onlyPastDate={(rule, value, cb) => {
            if (moment() > value) {
              cb()
            } else {
              cb("Data non valida");
            }
          }}

          nazioni={this.props.GlobalStore.stubs.nazione}
          province={this.props.GlobalStore.stubs.provincia}

          readOnly={this.state.readOnly}

          selectedStatoNascita={() => {
            //console.log (this.formRefDatiRappr.props.form);
            this.setState({
              comuni_nascita: [],
            }, () => {
              this.formRefDatiRappr.props.form.setFieldsValue({ comune_nascita: null, provincia_nascita: null });
            });
          }}

          selectedProvinciaNascita={data => {
            //console.log (this.formRefDatiRappr.props.form);

            this.setState({
              selected_nascita_provincia: data,
              comuni_nascita: [],
              loading: true,
            }, () => {
              this.formRefDatiRappr.props.form.setFieldsValue({ comune_nascita: null })
              this.selectedProvinciaNascita(data);
            });
          }}

          comuniNascita={this.state.comuni_nascita.map(e => {
            return {
              key: 'comune_nascita' + e.id,
              value: e.id,
              label: e.comune
            }
          })
        }

        selectedStatoResidenza={() => {
            //console.log (this.formRefDatiRappr.props.form);
            this.setState({
              comuni_residenza: [],
            }, () => {
              this.formRefDatiRappr.props.form.setFieldsValue({ comune_residenza: null, provincia_residenza: null });
            });
          }}

          selectedProvinciaResidenza={data => {
            //console.log (this.formRefDatiRappr.props.form);

            this.setState({
              selected_residenza_provincia: data,
              comuni_residenza: [],
              loading: true,
            }, () => {
              this.formRefDatiRappr.props.form.setFieldsValue({ comune_residenza: null })
              this.selectedProvinciaResidenza(data);
            });
          }}

          comuniResidenza={this.state.comuni_residenza.map(e => {
            return {
              key: 'comune_residenza' + e.id,
              value: e.id,
              label: e.comune
            }
          })
        }

        />

            <div style={{ textAlign: "center" }}>
              <Button
                type="primary"
                className="bg-green"
                loading={this.state.loading}
                icon="save"
                disabled={this.state.readOnly}
                onClick={() => this.submitDatiRequest()}
              >
                Procedi con il cambio Rappresentante Legale
              </Button>
            </div>

            <br/><br/>

      </div>
    );
    }
}

export default DatiNuovoLR